import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';

const MAX_HIGHLIGHTS_TO_SHOW = 8;
@Component({
  standalone: true,
  selector: 'base-highlights',
  templateUrl: './highlights.component.html',
  styleUrls: ['./highlights.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class HighlightsComponent {

  MAX_HIGHLIGHTS_TO_SHOW = MAX_HIGHLIGHTS_TO_SHOW;

  readonly highlights = input<string[]>([]);
  private _isExpanded = signal(false);

  // Computed signal for filtered highlights
  readonly filteredHighlights = computed(() => {
    const highlights = this.highlights();
    return highlights.filter(highlight => highlight !== '');
  });

  readonly hasMoreHighlights = computed(() => {
    return this.filteredHighlights().length > MAX_HIGHLIGHTS_TO_SHOW;
  });

  readonly highlightsToShow = computed(() => {
    return this.filteredHighlights()
      .slice(0, this._isExpanded() ? this.filteredHighlights().length : MAX_HIGHLIGHTS_TO_SHOW);
  });

  toggleViewMoreComments() {
    this._isExpanded.set(!this._isExpanded());
  }

  get isExpanded() {
    return this._isExpanded();
  }
}

